module.exports = __webpack_public_path__ + "img/image5.a2b78f23.png";